import { iso8601ToDate } from "@/utils/iso8601ToDate";

export interface TBankRecurentStatusDto {
    orderId: string;
    writeOffTime: string;
    createdAt: string;
    updatedAt: string;
    amount: number;
    rebillId: string;
}


export interface TBankRecurentStatusDomain {
    orderId: string;
    writeOffTime: Date | null;
    createdAt: Date | null;
    updatedAt: Date | null;
    amount: number;
    rebillId: string;
}

export const mapTBankRecurentStatusDtoToDomain = (dto: TBankRecurentStatusDto): TBankRecurentStatusDomain => {
    return {
        orderId: dto.orderId,
        writeOffTime: iso8601ToDate(dto.writeOffTime),
        createdAt: iso8601ToDate(dto.createdAt),
        updatedAt: iso8601ToDate(dto.updatedAt),
        amount: dto.amount,
        rebillId: dto.rebillId,
    }
}
